export const FILTER_COLUMNS = [
  {
    id: "status",
    label: "Status",
    options: [
      { value: "building", label: "Drafting" },
      { value: "planning", label: "Planning" },
      { value: "running", label: "Running" },
      { value: "complete", label: "Complete" },
      { value: "archived", label: "Archived" },
    ],
  },
  {
    id: "result",
    label: "Result",
    options: [
      { value: "control", label: "Variant A Won" },
      { value: "variant", label: "Variant B Won" },
      { value: "inconclusive", label: "Inconclusive" },
    ],
  },
  {
    id: "scope",
    label: "Scope",
    options: [
      { value: "title", label: "Title" },
      { value: "bullets", label: "Bullets" },
    ],
  },
];
